import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class SetupGuideService {
    private openSource = new Subject<Event>();
    open$ = this.openSource.asObservable();

    open(event: Event): void {
        this.openSource.next(event);
    }
}
